import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class GeneralLedgerService {
    private baseApiUrl: string;

    constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
      sortColumn: string, sortAscending: boolean, forBank:boolean,isMaintenance: boolean = true): Observable<any> {

      const params = {
        filter, pageIndex, pageSize, sortColumn, sortAscending,forBank, isMaintenance
      };
      return this.httpClient.post(this.baseApiUrl + 'generalledger/filter', params).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    getBankGlFiltered(filter: string, pageIndex: number, pageSize: number,
      sortColumn: string, sortAscending: boolean, forBank:boolean,isMaintenance: boolean = true): Observable<any> {

      const params = {
        filter, pageIndex, pageSize, sortColumn, sortAscending,forBank, isMaintenance
      };
      return this.httpClient.post(this.baseApiUrl + 'generalledger/bankglfilter', params).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    getAll(forMaintenance: boolean = false): Observable<any> {
       return this.httpClient.get(this.baseApiUrl + `generalledger?isMaintenance=${forMaintenance}`).pipe(
        map((res: any) =>  res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `generalledger/${id}?isMaintenance=${forMaintenance}`).pipe(
        map((res: Response) => this.addLedgerDisplayData(res)),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByCode(code: string): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `generalledger/code/${code}`).pipe(
        map((res: Response) => this.addLedgerDisplayData(res)),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByApplicationModuleId(moduleId: number):  Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `generalledger/application/${moduleId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(generalLedger: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `generalledger`, generalLedger).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(generalLedger: any): Observable<any> {
      return this.httpClient.put(this.baseApiUrl + `generalledger`, generalLedger).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `generalledger/authorise`, id).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
      return this.httpClient.delete(this.baseApiUrl + `generalledger/${id}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    addLedgerDisplayData(ledger: any): any {
      ledger.displayData = `${ledger.description} - ${ledger.code}`;
      
    return ledger;
    }

getPhysicalCash(currencyId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `generalledger/getphysicalcash?currencyId=${currencyId}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
  }
